// === Shopify EUR→BGN Fixed-Rate Currency Converter v1.3 ===
(function (window, document) {
  'use strict';

  if (window.BgnEurLiveConverter) return;

  const DEFAULTS = {
    fixedRate: 1.95583,
    selectors: [
      '.price',
      '.money',
      '[class*="price"]',
      '.amount',
      '[class*="amount"]',
      '.cart__price',
      'ins',
      '.cart__price span',
      'sale-price',
    ],
    batchTime: 50,
    idleDelay: 200,
    debug: false,
    localeBG: 'bg-BG',
    localeEU: 'en-US',
    decimals: 2,
  };

  let cfg, rateEURtoBGN, observer, enabled;
  let isProcessing = false;
  const stats = {converted: 0, skipped: 0, errors: 0, lastBatch: 0};

  function log(...args) {
    cfg.debug && console.debug('[EUR→BGN]', ...args);
  }

  function initConfig(userCfg = {}) {
    cfg = {...DEFAULTS, ...userCfg};
  }

  function setFixedRate() {
    rateEURtoBGN = cfg.fixedRate;
    log('Fixed rate set: 1 EUR =', rateEURtoBGN, 'BGN');
  }

  function extractNumber(str) {
    const cleaned = str.replace(/[^\d,.-]/g, '').trim();
    if (/^\d{1,3}\.\d{3}$/.test(cleaned)) {
      return parseFloat(cleaned.replace(/\./g, ''));
    }
    if (cleaned.includes(',') && cleaned.lastIndexOf(',') > cleaned.lastIndexOf('.')) {
      return parseFloat(cleaned.replace(/\./g, '').replace(',', '.'));
    }
    return parseFloat(cleaned.replace(/,/g, ''));
  }

  function format(num, locale) {
    return new Intl.NumberFormat(locale, {
      minimumFractionDigits: cfg.decimals,
      maximumFractionDigits: cfg.decimals,
    }).format(num);
  }

  const moneyRE = new RegExp(
    ['(?<!\\()', '([0-9]{1,3}(?:[.,][0-9]{3})*(?:[.,][0-9]{1,2})?)', '\\s*', '([€]|EUR)', '(?![^()]*\\))'].join(''),
    'gi'
  );

  function alreadyConverted(text) {
    return /лв|BGN/i.test(text);
  }

  // Convert inline without creating wrapper spans - just append the BGN text
  function convertTextNode(node) {
    const txt = node.textContent;
    if (!txt || alreadyConverted(txt) || !moneyRE.test(txt)) {
      return false;
    }

    // Reset regex lastIndex
    moneyRE.lastIndex = 0;

    const newText = txt.replace(moneyRE, (match) => {
      const n = extractNumber(match);
      if (isNaN(n) || n <= 0) {
        stats.skipped++;
        return match;
      }
      const converted = n * rateEURtoBGN;
      const formatted = format(converted, cfg.localeBG);
      stats.converted++;
      return `${match} | ${formatted} лв`;
    });

    if (newText !== txt) {
      node.textContent = newText;
      return true;
    }
    return false;
  }

  function collectTextNodes() {
    const walker = document.createTreeWalker(
      document.body,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode(node) {
          if (!node.nodeValue.trim() || node.parentElement.tagName.toLowerCase() === 'del') {
            return NodeFilter.FILTER_REJECT;
          }
          // Skip if already has BGN
          if (alreadyConverted(node.nodeValue)) {
            return NodeFilter.FILTER_REJECT;
          }
          return node.parentNode.closest(cfg.selectors.join(',')) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        },
      },
      false
    );

    const out = [];
    let n;
    while ((n = walker.nextNode())) out.push(n);
    return out;
  }

  function scanAndConvert() {
    if (!enabled || isProcessing) return;
    isProcessing = true;

    const nodes = collectTextNodes();

    nodes.forEach((node) => {
      try {
        convertTextNode(node);
      } catch (e) {
        stats.errors++;
        log('Conversion error:', e);
      }
    });

    isProcessing = false;
  }

  function startObserver() {
    if (!('MutationObserver' in window)) return;

    observer = new MutationObserver((mutations) => {
      if (isProcessing) return;

      // Check if any mutation contains EUR prices that need conversion
      const needsConversion = mutations.some((m) => {
        // Check added nodes for EUR prices
        for (const n of m.addedNodes) {
          if (n.nodeType === Node.TEXT_NODE && /€|EUR/.test(n.textContent) && !alreadyConverted(n.textContent)) {
            return true;
          }
          if (n.nodeType === Node.ELEMENT_NODE && /€|EUR/.test(n.textContent) && !alreadyConverted(n.textContent)) {
            return true;
          }
        }
        // Check characterData changes
        if (
          m.type === 'characterData' &&
          /€|EUR/.test(m.target.textContent) &&
          !alreadyConverted(m.target.textContent)
        ) {
          return true;
        }
        return false;
      });

      if (!needsConversion) return;

      clearTimeout(observer._timer);
      observer._timer = setTimeout(scanAndConvert, cfg.idleDelay);
    });

    observer.observe(document.body, {childList: true, subtree: true, characterData: true});
  }

  const api = {
    init(options) {
      initConfig(options);
      enabled = true;
      setFixedRate();
      scanAndConvert();
      startObserver();
      log('Converter initialized (fixed rate).');
    },
    pause() {
      enabled = false;
    },
    resume() {
      enabled = true;
      scanAndConvert();
    },
    updateRate(newRate) {
      cfg.fixedRate = newRate;
      setFixedRate();
    },
    resetStats() {
      Object.assign(stats, {converted: 0, skipped: 0, errors: 0, lastBatch: 0});
    },
    getStats() {
      return {...stats};
    },
    disable() {
      this.pause();
      if (observer) observer.disconnect();
      log('Converter disabled.');
    },
  };

  window.BgnEurLiveConverter = api;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => api.init(), {once: true});
  } else {
    api.init();
  }
})(window, document);
